/**
 * E-Mail-Bestätigung / OAuth (PKCE) kann fälschlich auf die Site-URL (/) mit ?code= landen
 * statt auf /auth/callback. Dann passt die redirect_uri nicht zur Registrierung → keine Session,
 * Nutzer bleibt auf der Startseite mit „Einloggen“.
 *
 * Muss vor dem ersten Supabase-Client-Lauf ausgeführt werden → erster Import in main.tsx.
 */

/** @internal export für Unit-Tests */
export function getAuthCallbackRecoveryUrl(
  pathname: string,
  search: string,
  hash: string,
  origin: string
): string | null {
  const isRoot =
    pathname === "/" || pathname === "" || pathname === "/index.html";
  if (!isRoot) return null;

  let hasQueryAuth = false;
  if (search.length > 1) {
    try {
      const params = new URLSearchParams(
        search.startsWith("?") ? search.slice(1) : search
      );
      hasQueryAuth =
        params.has("code") ||
        params.has("error") ||
        params.has("error_description");
    } catch {
      hasQueryAuth =
        search.includes("code=") ||
        search.includes("error=") ||
        search.includes("error_description=");
    }
  }

  const hasHashAuth =
    hash.length > 1 &&
    (hash.includes("access_token=") ||
      hash.includes("error=") ||
      hash.includes("error_description=") ||
      hash.includes("type=recovery"));

  if (!hasQueryAuth && !hasHashAuth) return null;

  return `${origin}/auth/callback${search}${hash}`;
}

if (typeof window !== "undefined") {
  const target = getAuthCallbackRecoveryUrl(
    window.location.pathname,
    window.location.search,
    window.location.hash,
    window.location.origin
  );
  if (target) {
    window.location.replace(target);
  }
}
